import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { GamesService } from '../../../services/games.service';
import { GridOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'cv-revert-payout-details',
  templateUrl: './revert-payout-details.component.html',
  styleUrls: ['./revert-payout-details.component.scss']
})
export class RevertPayoutDetailsComponent implements OnInit {
  @Input() payouts: any;
  @Input() shouldDisplayCustomRewardMessage: boolean = false;
  @ViewChild('revertPayoutGrid') agGrid: AgGridAngular;

  gs = null;
  loginList = [];
  flag: boolean = false;
  isButtonDisabled: boolean;
  payoutDetails: GridOptions = null;
  countRows: number;

  constructor(
    private gamesService: GamesService,
    private dialogService: CvDialogService,
    private activeModalService: NgbActiveModal,
    private agGridHelperService: AgGridHelperService
  ) { 
    this.gs = this.gamesService.data;
    this.gs.confirmBox = false;
    this.isButtonDisabled = true;
    this.countRows = 0;
  }

  ngOnInit(): void {
    this.setupGrid();
  }

  setupGrid(){
    this.payoutDetails = this.agGridHelperService.createGridOptions({
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      },
      columnDefs: this.getColumns(),
      rowData: [],
      animateRows: true,
      suppressContextMenu: true,
      suppressCellFocus: true,
      suppressRowHoverHighlight: true,

      components: {
        groupRenderer: this.agGridHelperService.GroupDrillDownCellRenderer,
      },
      onGridSizeChanged: (e) => {
        e.api.sizeColumnsToFit();
      },
      getRowId: ({data: rowData}) => {
        return rowData.interval;
      },
      onRowSelected: (params) => {
        if (params.node.isSelected()) {
          this.countRows++;
          if (this.isButtonDisabled) {
              this.isButtonDisabled = false;
          }
        } else {
          this.countRows--;
        }

        if (this.countRows == 0) {
          this.isButtonDisabled = true;
        }
      }
    });
    this.loadGrid();
  }

  loadGrid(): void {
    var rowData = [];
    this.loginList = [];

    for (var i = 0; i < this.payouts.data.length; i++) {
      //Grouping agent level games data
      if (this.gs.selectedGame[0].GameType != 8) {
        if (rowData.filter((x) => { return x.interval == this.payouts.data[i].interval }).length == 0) {
          rowData.push({
            interval: this.payouts.data[i].interval,
            coins: this.payouts.data[i].coins,
            xp: this.payouts.data[i].xp,
            badges: this.payouts.data[i].badges,
            custom: this.payouts.data[i].custom,
          });
        } else {
          rowData[rowData.length - 1].coins += this.payouts.data[i].coins;
          rowData[rowData.length - 1].xp += this.payouts.data[i].xp;
          rowData[rowData.length - 1].badges += this.payouts.data[i].badges;
          rowData[rowData.length - 1].custom += this.payouts.data[i].custom;
        }

        this.loginList.push(this.payouts.data[i].loginID);
      } else { //Grouping team level games data
        if (rowData.filter((x) => { return (x.interval == this.payouts.data[i].interval && x.interval && x.teamID == this.payouts.data[i].teamID) }).length == 0) {
          rowData.push({
            teamID: this.payouts.data[i].teamID,
            teamName: this.payouts.data[i].teamName,
            interval: this.payouts.data[i].interval,
            coins: this.payouts.data[i].coins,
            xp: this.payouts.data[i].xp,
            badges: this.payouts.data[i].badges,
            custom: this.payouts.data[i].custom
          });
        } else {
          rowData[rowData.length - 1].coins += this.payouts.data[i].coins;
          rowData[rowData.length - 1].xp += this.payouts.data[i].xp;
          rowData[rowData.length - 1].badges += this.payouts.data[i].badges;
          rowData[rowData.length - 1].custom += this.payouts.data[i].custom;
        }
      }
    }

    if (this.agGrid?.api) {
      this.agGrid.api.setRowData(rowData);
    } else {
      this.payoutDetails.rowData = rowData;
    }
  }

  revertPayment(): void {
    var payoutsData = this.payouts;
    var selectedRows = this.agGrid.api.getSelectedRows();
    var selectedLogins = [];

    if (this.gs.selectedGame[0].GameType == 8) {
      for (var i = 0; i < selectedRows.length; i++) {
        var tmp = payoutsData.data.filter((item) => { return item.teamID == selectedRows[i].teamID });
        for (var j = 0; j < tmp.length; j++) {
          selectedLogins.push(tmp[j].loginID);
        }
      }
    } else {
      selectedLogins = this.loginList;
    }

    if (!this.isButtonDisabled) {
      this.dialogService.showConfirmDialog(
        this.gamesService.getGamesHistoryMessages("Confirm_Revert_Title", "Confirm_Action"),
        this.gamesService.getGamesHistoryMessages("Confirm_Revert_Message", "Do you want to revert the payments made on the intervals selected? This action cannot be undone."),
        false,
        () => {
          this.isButtonDisabled = false;
          this.gamesService.revertGamePayment(payoutsData, selectedLogins);
          this.gs.confirmBox = true;

          var columnDefs = this.getColumns();
          columnDefs[0].checkboxSelection = false;

          if (this.agGrid.api) {
            this.agGrid.api.setColumnDefs(columnDefs);
            this.agGrid.api.sizeColumnsToFit();
          }

          this.flag = true;
        },
        () => {
          this.agGrid.api.deselectAll();
        }
      );
    }
  }

  getColumns() {
    const customRewardColumn = (this.gs.selectedGame[0]?.GameType == 9 || this.gs.selectedGame[0]?.GameType == 10)? 
      [
        {
          field: 'custom',
          headerName: this.gamesService.getGamesHistoryMessages("Custom_Rewards", "Custom Rewards"),
          width: 100,
          cellRenderer: (params) => {
            if(params.value > 1) {
              return `${params.value} ${this.gamesService.getGamesHistoryMessages("Custom_Rewards", "Custom Rewards")}`;
            }
            return `${params.value} ${this.gamesService.getGamesHistoryMessages("Custom_Reward", "Custom Reward")}`;
          }
        }
      ] : 
      [];
    const columns: any = [
      { field: 'interval', headerName: this.gamesService.getGamesHistoryMessages("Interval", "Interval"), width: 95 },
      { field: 'coins', headerName: this.gamesService.getGamesHistoryMessages("Coins", "Coins"), width: 75 },
      { field: 'xp', headerName: this.gamesService.getGamesHistoryMessages("XP", "XP"), width: 75 },
      { field: 'badges', headerName: this.gamesService.getGamesHistoryMessages("Badges", "Badges"), width: 75 },
      ...customRewardColumn,
    ];

    if (this.gs.selectedGame[0].GameType != 8) {
      columns[0].checkboxSelection = this.isButtonDisabled;
    } else {
      columns.unshift({ field: 'teamName', headerName: this.gamesService.getGamesHistoryMessages("Team", "Team"), width: 95, checkboxSelection: this.isButtonDisabled });
    }

    return columns;
  }

  getButtomClass(): string {
    return this.isButtonDisabled ? 'btn btn-primary disabled' : 'btn btn-primary';
  }

  closeModal(): void {
    if (this.flag) {
      this.gs.modalResponse = "PaymentReverted";
      this.flag = false;
    }

    this.activeModalService.close();
  }

  cancel() {
    $(document).trigger(new jQuery.Event('cancelRevertSelection'));
    this.activeModalService.close();
  }
}